/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, FieldArray, Form } from 'formik';
import { Button, Table } from 'reactstrap';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';

const EditablePlanField = ({ plan, index, setFieldValue }) => (
  <>
    <tr key={index}>
      <td>
        <Field
          name={`plans.${index}.duration`}
          type="text"
          component={FormikInputField}
          placeholder="Duration"
          disabled
        />
      </td>
      <td>
        <Field
          name={`plans.${index}.price`}
          type="number"
          component={FormikInputField}
          placeholder="Price"
          onChange={(e) => {
            const price = Number(e.target.value);
            setFieldValue(`plans.${index}.price`, price);

            const discountValue = Number(plan.discountedPercentage);
            const discountedPrice = price - (discountValue * price) / 100;

            setFieldValue(
              `plans.${index}.discountedAmount`,
              discountedPrice.toFixed(2), // Ensure only two decimal places
            );
          }}
          // disabled
        />
      </td>
      <td>
        <Field
          name={`plans.${index}.discountedPercentage`}
          type="number"
          component={FormikInputField}
          placeholder="Discount"
          onChange={(e) => {
            const discountValue = Number(e.target.value);
            setFieldValue(`plans.${index}.discountedPercentage`, discountValue);
            const discountedPrice =
              Number(plan.price) - (discountValue * Number(plan.price)) / 100;
            setFieldValue(
              `plans.${index}.discountedAmount`,
              discountedPrice.toFixed(2), // Ensure only two decimal places
            );
          }}
        />
      </td>
      <td>
        <Field
          name={`plans.${index}.discountedAmount`}
          type="number"
          component={FormikInputField}
          placeholder="Discounted Price"
          onChange={(e) => {
            const discountedPrice = Number(e.target.value);
            if (discountedPrice > Number(plan.price))
              return alert('Discounted price should be less than actual price');
            setFieldValue(`plans.${index}.discountedAmount`, discountedPrice);
            const discountValue =
              ((Number(plan.price) - discountedPrice) / Number(plan.price)) *
              100;
            setFieldValue(
              `plans.${index}.discountedPercentage`,
              discountValue.toFixed(2),
            ); // Ensure only two decimal places
          }}
        />
      </td>
    </tr>
    <tr>
      <td colSpan={4} className="p-3 text-field">
        <Field
          label="Description"
          name={`plans.${index}.description`}
          type="textarea"
          className="msg-field text-start"
          component={FormikInputField}
          // required
          disabled
        />
      </td>
    </tr>
  </>
);

const EditPlansForm = (props) => {
  const {
    handleSubmit,
    drawerToggle,
    isValid,
    dirty,
    isSubmitting,
    setFieldValue,
  } = props;

  return (
    <Form onSubmit={handleSubmit} className="table-border">
      <FieldArray name="plans">
        {({ form }) => (
          <Table bordered className="common-table plan-table mb-0">
            <thead>
              <tr>
                <th>Duration</th>
                <th>Actual Price</th>
                <th>Discount (%)</th>
                <th>Discounted Price</th>
              </tr>
            </thead>
            <tbody>
              {form.values.plans.map((plan, index) => (
                <EditablePlanField
                  key={index}
                  plan={plan}
                  index={index}
                  setFieldValue={setFieldValue}
                />
              ))}
            </tbody>
          </Table>
        )}
      </FieldArray>

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          Update
        </LoadingButton>
      </div>
    </Form>
  );
};

export default EditPlansForm;
